module.exports = __webpack_public_path__ + "img/img-0dc72e.png";